import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import ProjectsViewDefault from './Default/ProjectsView';
import ProjectsViewPlayful from './Playful/ProjectsView';

export function ProjectsView(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();

  return isPlayfulStudentTheme ? <ProjectsViewPlayful {...props} /> : <ProjectsViewDefault {...props} />;
}
